module.exports = __webpack_public_path__ + "img/white-arrow.d2301396.svg";